import { createContext, type ReactNode, useContext } from "react";

const HeraldChatPngExportSuppressedContext = createContext(false);

interface HeraldChatPngExportSuppressedProviderProps {
  readonly children: ReactNode;
}

/** Descendant catalog nodes skip per-component PNG toolbars (e.g. chart inside exporting `Card`). */
export const HeraldChatPngExportSuppressedProvider = ({
  children,
}: HeraldChatPngExportSuppressedProviderProps) => (
  <HeraldChatPngExportSuppressedContext.Provider value={true}>
    {children}
  </HeraldChatPngExportSuppressedContext.Provider>
);

export const useHeraldChatPngExportSuppressed = (): boolean =>
  useContext(HeraldChatPngExportSuppressedContext);
